// @flow

import styled from 'styled-components';

export const VoucherListing = styled.div``;

export const VoucherListingWrapper = styled.div`
  background: rgb(248, 248, 249);
  color: rgb(115, 128, 147);
  border-radius: 6px;
  padding: 16px;
  margin: 0 auto;

  &:empty {
    display: none;
  }

  @media (min-width: 540px) {
    width: 80%;
  }
`;

export const VoucherListingItem = styled.div`
  font-size: 1.15em;
  padding: 16px 0;
  border-bottom: 1px solid rgba(203, 203, 203, 0.25);
  &:last-child {
    border: none;
  }
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
`;

export const VoucherListingItemTitle = styled.div`
  flex-basis: 0;
  flex-grow: 1;
`;

export const VoucherListingItemValue = styled.div`
  width: 100%;
  flex-basis: 0;
  flex-grow: 1;
  font-weight: bold;
  text-align: right;
`;
